import request from '@/service/api'
import ConfigType from '@/service/api/type'
import qs from 'qs'

enum dicApi {
    DICDATA = '/WareDictData/listbycodelist',
    TIMEDATA = '/StockList/DateList',
    UPDATATIME = '/StockList/UpdateDateTime',
    Synchronize = '/ERP/addMaterial1'
}
export const getDicListData = (data: any): ConfigType<any> => {
    return request({
        url: `${dicApi.DICDATA}?${qs.stringify(data)}`,
    })
}
export const getTimeData = (): ConfigType<any> => {
    return request({
        url: `${dicApi.TIMEDATA}`,
    })
}
export const updataTime = (data: any): ConfigType<any> => {
    return request({
        url: dicApi.UPDATATIME,
        method: 'post',
        data
    })
}
export const chronizeInfo = (): ConfigType<any> => {
    return request({
        url: dicApi.Synchronize,
        method: 'post'
    })
}
